import { ConfigService } from './config.service';
import { Cuenta } from '../models/cuenta';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog'
import { TokenService } from '../utils/token.service';
import { environment } from 'src/environments/environment';
import { CuentaDistribuidor } from '../models/cuentaDistribuidor';
import { Direccion } from '../models/direccion';

@Injectable({
  providedIn: 'root'
})
export class CuentasService {

  private cuentasServerUri: string;
  private apiUrl = environment.apiUrl;

  constructor(private configService: ConfigService, private dialog: MatDialog, private httpCliente: HttpClient,
    private tokenService: TokenService) {
    this.cuentasServerUri = /*this.configService.ServerURI*/this.apiUrl  + '/' + this.configService.CuentasURI;
  }
  private getHeaders() {
    const authToken = this.tokenService.getAuthToken();
    const authTokenBearer = this.tokenService.getAuthTokenBearer();

    return new HttpHeaders({
      'Authorization': `Bearer ${authTokenBearer}`,      
      'PortalO2G' : `${authToken}`
    });
  }

  cCuentas(userName: string, adm: boolean) {
    return this.httpCliente.get(this.cuentasServerUri + 'CCuentas?userName=' + userName + "&adm=" + adm, { headers: this.getHeaders() });
  }
  cCuentaDb(codigo: number) {
    return this.httpCliente.get(this.cuentasServerUri + 'CCuentaDB?codigo=' + codigo, { headers: this.getHeaders() });
  }

  mCuenta(model: Cuenta) {
    return this.httpCliente.post(this.cuentasServerUri + 'MCuenta', model, { headers: this.getHeaders() });
  }
  cDirecciones(idPais: string, idCompania: string, idSalesOrg: string, nroCliente: string) {
    return this.httpCliente.get(this.cuentasServerUri + 'CDirecciones?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&nroCliente=" + nroCliente, { headers: this.getHeaders() });
  }

  cCuentasDistribuidores(idPais: string, idCompania: string, idSalesOrg: string, nroCliente: string) {
    return this.httpCliente.get(this.cuentasServerUri + 'CCuentasDistribuidores?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&nroCliente=" + nroCliente, { headers: this.getHeaders() });
  }
  cCuentaDistribuidorDb(codigo: number) {
    return this.httpCliente.get(this.cuentasServerUri + 'CCuentaDistribuidorDB?codigo=' + codigo, { headers: this.getHeaders() });
  }
  mCuentaDistribuidor(model: CuentaDistribuidor) {
    return this.httpCliente.post(this.cuentasServerUri + 'MCuentaDistribuidor', model, { headers: this.getHeaders() });
  }

  mDireccion(model: Direccion) {
    return this.httpCliente.post(this.cuentasServerUri + 'MDireccion', model, { headers: this.getHeaders() });
  }

}
